import { useState, useEffect } from 'react'

export function useMediaQuery(query: string): boolean {
  // Initialize with the actual match state
  const [matches, setMatches] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.matchMedia(query).matches
    }
    return false
  })

  useEffect(() => {
    const media = window.matchMedia(query)

    // Set initial value
    setMatches(media.matches)

    const listener = (e: MediaQueryListEvent) => setMatches(e.matches)

    // Use the newer addEventListener API
    media.addEventListener('change', listener)

    return () => media.removeEventListener('change', listener)
  }, [query])

  return matches
}
